export enum RouteComponents {
  FINISHED,
  LANDING,
  UPLOAD,
  UPLOAD_DEBUG,
  UPLOAD_MANUAL,
  UPLOAD_MANUAL_COBORROWER,
  VERIFF,
  ESCAPE_HATCH,
}



// WEBPACK FOOTER //
// ./src/constants/RouteComponents.ts